import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import heroIllustration from "@/assets/hero-illustration.jpg";
const ModernHero = () => {
  const heroRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll(".reveal");
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add("active");
            }, index * 100);
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (heroRef.current) {
      observer.observe(heroRef.current);
    }
    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);
  const handleStartCollaborating = () => {
    navigate('/pricing');
  };
  return <section ref={heroRef} className="relative bg-gradient-to-br from-primary via-primary to-saas-navy pt-24 lg:pt-32 pb-20 lg:pb-28 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h1 className="reveal text-display-lg text-white leading-tight">
              Embrace the future of
              <span className="block mt-2 italic">leaseholder management</span>
            </h1>
            
            <p className="reveal text-h3 text-white/90 leading-relaxed">
              Manage shared finances. Collaborate with other property owners. Access documents in one place.
            </p>
            
            <div className="reveal">
              <Button size="lg" className="bg-saas-blue text-white hover:bg-saas-blue/90 font-semibold px-8 py-6 text-lg h-auto shadow-lg hover:shadow-xl transition-all group" onClick={handleStartCollaborating}>
                Get Started Now
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
          
          {/* Right Visual - Hero Illustration */}
          <div className="reveal relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-2 border-white/10">
              <img src={heroIllustration} alt="Property management collaboration illustration showing FlatJive dashboard interface" className="w-full h-auto" loading="eager" fetchPriority="high" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ModernHero;